export default "__VITE_ASSET__f8FojYaE__"